import dayjs from "@/lib/dayjs";

export function formatDate(date: string, format = "YYYY-MM-DD") {
	return dayjs(date).format(format);
}

/**
 * Unix Timeをフォーマットに変換
 * @param unixTime
 * @param format （デフォルト：YYYY年MM月DD日（dd） HH時mm分）
 * @returns
 */
export function formatUnixTimeToDate(unixTime: number, format = "YYYY年MM月DD日（dd） HH時mm分"): string {
	return dayjs(unixTime).locale("ja").format(format);
}
